
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choose-your-plan",
      function () {
        return require("private-next-pages/choose-your-plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/choose-your-plan"])
      });
    }
  